module.exports = __webpack_public_path__ + "images/emoji/arrow_lower_left.af23f6adc3ae69e5c6e1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/arrow_lower_left.png
// module id = DNec
// module chunks = 2